import axios from "axios";
import day from 'dayjs'
import number_format from '@/utilities/formatting/number_format'

export default {
    state: {
        codeData: {
            paper: [],
            plate: [],
            printing: [],
            coating: [],
            thompson: [],
            bonding: [],
            subsidiary: [],
            processing: [],
            delivery: [],
        },
        estimations: [],
        queryOptions: {
            prevKey: 'orders.id',
            queryKey: 'orders.id',
            queryOrder: 'desc',
            queryText: null,
            page: 1
        },
    },
    mutations: {
        setCodeData: function(state, payload) {
            state.codeData = payload
        },
        setEstimations: function(state, payload) {
            state.estimations = payload
        },
        setEstimationQueryOptions: function(state, payload) {
            state.queryOptions = payload
        }
    },
    getters: {
        getEstimationOptions: async function(state) {
            return state.options
        },
        getEstimationQueryOptions: async function(state) {
            return state.queryOptions
        },
        getEstimations: async function(state) {
            return state.estimations
        }
    },
    actions: {
        async getCodeData(commit) {

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.getters.getAccessToken
                },
                url: this.getters.getApiUrl + '/api/v1/estimation/getList',
                timeout: this.getters.getApiRequestTimeLimit
            })
            .then(response => {

                console.log("위치 - store/estimaion/index.js:getCodeData")
                console.log(response.data)

                if(response.data && response.data.status != '9999') {

                    commit('setCodeData', response.data)

                }else{

                    commit('setCodeData', [])

                }

            })

        },
        async getEstimations({ state, commit }) {

            const queryOptions = state.queryOptions

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.getters.getAccessToken
                },
                url: this.getters.getApiUrl + '/api/v1/estimation/getEstimations',
                data: queryOptions,
                timeout: this.getters.getApiRequestTimeLimit
            })
            .then(response => {

                if(response.data && response.data.status != '9999') {

                    const tmpResult = response.data
                    const tmpEstimations = []

                    let i = 0
                    for (const item of response.data.data) {

                        let unitPrice = item.unitPrice
                        if(item.finalUnitPrice){
                            unitPrice = item.finalUnitPrice
                        }

                        item.estimationDate = day(item.estimationDate).format('YY/MM/DD')
                        item.finalPriceSummary = number_format(unitPrice) + '원 / ' + number_format(item.quantities) + '매 / ' + number_format(item.finalTotalPrice) + '원'

                        tmpEstimations[i] = item
                        i++

                    }

                    tmpResult.data = tmpEstimations
                    commit('setEstimations', tmpResult)

                }else{

                    commit('setEstimations', [])

                }

            })

        },
        setEstimationOptions({ commit }, payload) {
            commit('getCodeData', payload)
        },
        setEstimationQueryOptions({ commit }, payload) {
            commit('setEstimationQueryOptions', payload)
        },
    }
}